//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

// TODO: PD-270146 - remove this file when the ContentLibraryLabelsImprovements feature flag is released
(function () {
  angular.module('curalate').component('collectionMetrics', {
    bindings: {
      filterTipCallback: '&',
      itemStats: '<',
      showFilterTipCallback: '&',
    },
    template: require('@legacy-components/content/collection-metrics.html'),
    controller: [
      '$filter',
      'StatBubbleLabels',
      'StatBubbleNames',
      'StatBubbleTooltips',
      'STAT_FORMATTERS',
      function (
        $filter,
        StatBubbleLabels,
        StatBubbleNames,
        StatBubbleTooltips,
        STAT_FORMATTERS,
      ) {
        const self = this;

        self.STAT_TYPES = {
          PINTEREST: 'Pinterest',
          INSTAGRAM_POSTS: 'InstagramPosts',
          INSTAGRAM_STORIES: 'InstagramStories',
        };

        const makePretty = (value) => {
          const prettyVal = $filter('number')(value, 0);
          if (prettyVal.length <= 13) {
            return prettyVal;
          } else {
            return $filter('readableNumber')(value);
          }
        };

        const processStoryAggregateStats = (value, name) => {
          switch (name) {
            case StatBubbleNames.AVG_REACH: {
              return {
                value: makePretty(value),
                label: StatBubbleLabels[name],
                tooltip: StatBubbleTooltips[name],
                order: 0,
              };
            }
            case StatBubbleNames.TOTAL_IMPRESSIONS: {
              return {
                value: makePretty(value),
                label: StatBubbleLabels[name],
                tooltip: StatBubbleTooltips[name],
                order: 1,
              };
            }
            case StatBubbleNames.AVG_COMPLETION_RATE: {
              return {
                filter: STAT_FORMATTERS.PERCENT,
                filterParams: [true],
                value,
                label: StatBubbleLabels[name],
                tooltip: StatBubbleTooltips[name],
                order: 2,
              };
            }
            default: {
              return null;
            }
          }
        };

        const processPinterestAggregateStats = (value, name) => {
          switch (name) {
            case StatBubbleNames.TOTAL_REPINS: {
              return {
                value: makePretty(value),
                label: StatBubbleLabels[name],
                tooltip: StatBubbleTooltips[name],
                order: 0,
              };
            }
            case StatBubbleNames.TOTAL_COMMENTS: {
              return {
                value: makePretty(value),
                label: StatBubbleLabels[name],
                tooltip: StatBubbleTooltips[name],
                order: 1,
              };
            }
            case StatBubbleNames.AVG_REPINS: {
              return {
                value: makePretty(value),
                label: StatBubbleLabels[name],
                tooltip: StatBubbleTooltips[name],
                order: 2,
              };
            }
            case StatBubbleNames.AVG_COMMENTS: {
              return {
                value: makePretty(value),
                label: StatBubbleLabels[name],
                tooltip: StatBubbleTooltips[name],
                order: 3,
              };
            }
            default: {
              return null;
            }
          }
        };

        const processInstagramAggregateStats = (value, name) => {
          switch (name) {
            case StatBubbleNames.FOLLOWER_ENGAGEMENT_RATE: {
              return {
                filter: STAT_FORMATTERS.PERCENT,
                filterParams: [true],
                value,
                label: StatBubbleLabels[name],
                tooltip: StatBubbleTooltips[name],
                order: 0,
              };
            }
            case StatBubbleNames.TOTAL_LIKES: {
              return {
                value: makePretty(value),
                label: StatBubbleLabels[name],
                tooltip: StatBubbleTooltips[name],
                order: 1,
              };
            }
            case StatBubbleNames.AVG_LIKES: {
              return {
                value: makePretty(value),
                label: StatBubbleLabels[name],
                tooltip: StatBubbleTooltips[name],
                order: 2,
              };
            }
            case StatBubbleNames.TOTAL_COMMENTS: {
              return {
                value: makePretty(value),
                label: StatBubbleLabels[name],
                tooltip: StatBubbleTooltips[name],
                order: 3,
              };
            }
            case StatBubbleNames.AVG_COMMENTS: {
              return {
                value: makePretty(value),
                label: StatBubbleLabels[name],
                tooltip: StatBubbleTooltips[name],
                order: 4,
              };
            }
            default: {
              return null;
            }
          }
        };

        const processStats = (contentStats) => {
          if (self.itemStats.storyPercentage === 1.0) {
            self.stats = _.chain(contentStats)
              .pick([
                StatBubbleNames.AVG_REACH,
                StatBubbleNames.AVG_COMPLETION_RATE,
                StatBubbleNames.TOTAL_IMPRESSIONS,
              ])
              .mapObject(processStoryAggregateStats)
              .sortBy((stat) => {
                return stat ? stat.order : stat;
              })
              .value();
            self.displayedStatType = self.STAT_TYPES.INSTAGRAM_STORIES;
          } else if (self.itemStats.pinPercentage > 0.9) {
            self.stats = _.chain(contentStats)
              .pick([
                StatBubbleNames.AVG_REPINS,
                StatBubbleNames.TOTAL_REPINS,
                StatBubbleNames.AVG_COMMENTS,
                StatBubbleNames.TOTAL_COMMENTS,
              ])
              .mapObject(processPinterestAggregateStats)
              .sortBy((stat) => {
                return stat ? stat.order : stat;
              })
              .value();
            self.displayedStatType = self.STAT_TYPES.PINTEREST;
          } else {
            self.stats = _.chain(contentStats)
              .pick([
                StatBubbleNames.TOTAL_LIKES,
                StatBubbleNames.AVG_LIKES,
                StatBubbleNames.TOTAL_COMMENTS,
                StatBubbleNames.AVG_COMMENTS,
                StatBubbleNames.FOLLOWER_ENGAGEMENT_RATE,
              ])
              .mapObject(processInstagramAggregateStats)
              .sortBy((stat) => {
                return stat ? stat.order : stat;
              })
              .value();
            self.displayedStatType = self.STAT_TYPES.INSTAGRAM_POSTS;
          }
        };

        self.computeStatBubbleWrapperClass = () => {
          switch (self.displayedStatType) {
            case self.STAT_TYPES.INSTAGRAM_STORIES:
              return 'three-item-bubble-container';
            case self.STAT_TYPES.INSTAGRAM_POSTS:
              return 'six-item-bubble-container';
            default:
              return 'four-item-bubble-container';
          }
        };

        self.$onInit = function () {
          processStats(self.itemStats);
        };
      },
    ],
  });
})();
